import { Mapper } from './mapper';

export const EstadoCivil = Mapper.from([
  [1, 'Solteiro (a)'],
  [2, 'Casado (a)'],
  [3, 'Divorciado (a)'],
  [4, 'Separado (a) judicialmente'],
  [5, 'Viúvo (a)'],
]);
